@let layout = layoutSg();

<div
  class="atn-ds-empty-state"
  [class.atn-ds-empty-state--vertical]="layout === 'v'"
  [class.atn-ds-empty-state--horizontal]="layout === 'h'"
>
  <div
    class="atn-ds-empty-state__image-container"
    [style.backgroundImage]="imageSg()"
  ></div>
  <div class="atn-ds-empty-state__text-container">
    <h3>{{ titleSg() }}</h3>

    @let description = descriptionSg();
    @if (description) {
      <div class="atn-ds-empty-state__description">
        {{ description }}
      </div>
    }

    @if (action.observed) {
      <div class="atn-ds-empty-state__button-container">
        <atn-ds-button
          type="gray"
          (click)="action.emit()"
        >
          {{ actionSg() }}
          @if (typeSg() === 'error' || typeSg() === 'no-data') {
            <div class="atn-ds-empty-state__refresh-icon">
              <i class="atn-icon atn-reset atn-light"></i>
            </div>
          }
        </atn-ds-button>
      </div>
    }
  </div>
</div>
